import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Avatar, Button, Divider, Stack } from "@mui/material";
import { Images } from "../../assets/common";
import {
  formatedDate,
  fullName,
  getErrorString,
  getTimeDue,
  isOwnerId,
  truncate,
} from "../../constants/function";
import DoneIcon from "@mui/icons-material/Done";
import BuyNow from "../../components/BuyNow";
import TipPopup from "../../components/TipPopup";
import Loader from "../../components/Loader";
import ApiService from "../../services/api-service";
import notifier from "../../components/Notifier";
import { useDispatch } from "react-redux";
import { getBalance } from "../../asyncAction/asyncBalance";
import NoData from "../../components/Nodata";
import { useTranslation } from "react-i18next";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{ minHeight: "300px" }}
    >
      {value === index && (
        <Box sx={{ padding: "10px 0" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function PlaylistNftMoreData({
  playlistDetail,
  owners,
  nftIndex,
}) {
  const { t } = useTranslation("common");
  const [charges, setCharges] = React.useState({});
  const [offers, setOffers] = React.useState([]);
  const [activities, setActivities] = React.useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openTip, setOpenTip] = useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [viewMore, setViewMore] = React.useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) getOffers(playlistDetail["_id"]);
    if (newValue === 2) getActivities(playlistDetail["_id"]);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const handleClose = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTip(false);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const getOffers = async (playlistId) => {
    try {
      const response = await ApiService.OFFERS_PLAYLIST(playlistId);
      setOffers(response["result"]);
    } catch (error) {}
  };
  const getActivities = async (playlistId) => {
    try {
      const response = await ApiService.ACTIVITY_PLAYLIST(playlistId);
      setActivities(response["result"]);
    } catch (error) {}
  };

  const getCharges = async () => {
    try {
      const response = await ApiService.CHARGES();
      setCharges({ ...response["result"] });
    } catch (error) {}
  };

  React.useEffect(() => {
    getCharges();
  }, []);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }} position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          // textColor="default"
          variant="fullWidth"
          aria-label="Nft more details"
        >
          <Tab
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={
                  value === 0 ? Images.more_details_active : Images.more_details
                }
                alt=""
              />
            }
            label={t("nftDetail.tabs2.tab1")}
            {...a11yProps(0)}
          />
          <Tab
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 1 ? Images.offers_active : Images.offers}
                alt=""
              />
            }
            label={t("nftDetail.tabs2.tab2")}
            {...a11yProps(1)}
          />
          <Tab
            className="responsive-flex"
            sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
            icon={
              <img
                src={value === 2 ? Images.activity_active : Images.activity}
                alt=""
              />
            }
            label={t("nftDetail.tabs2.tab3")}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <Box
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        // onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Stack direction="column" spacing={2}>
            <Stack
              direction="row"
              sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}
            >
              <Stack direction="column" spacing={1}>
                <Stack direction="row" spacing={1}>
                  <Typography className="fs-14 fade-text fw-b white-secondary">
                    {t("nftDetail.detail.creator.text1")}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar"
                    src={
                      playlistDetail["createdByDetails"]["profileImg"]
                        ? playlistDetail["createdByDetails"]["profileImg"][
                            "filePath"
                          ]
                        : Images.user_dummy
                    }
                    alt=""
                  />
                  <Typography className="fs-14">
                    {fullName(playlistDetail["createdByDetails"])}
                  </Typography>
                  {playlistDetail["createdByDetails"]["isVerified"] ? (
                    <DoneIcon
                      color="primary"
                      sx={{
                        backgroundColor: "#2CF488",
                        borderRadius: "50%",
                        fontSize: "14px",
                        color: "#1E1E1E",
                        padding: "2px",
                      }}
                    />
                  ) : null}
                </Stack>
              </Stack>
              <Stack direction="column" spacing={1}>
                <Stack direction="row" spacing={1}>
                  <Typography className="fs-14 fade-text fw-b white-secondary">
                    {t("tipPopup.text2")}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar"
                    src={
                      owners?.owner?.profileImg?.filePath || Images.default_user
                    }
                    alt=""
                  />
                  <Typography className="fs-14">
                    {fullName(owners?.owner)}
                  </Typography>
                  {owners?.owners?.isVerified ? (
                    <DoneIcon
                      color="primary"
                      sx={{
                        backgroundColor: "#2CF488",
                        borderRadius: "50%",
                        fontSize: "14px",
                        color: "#1E1E1E",
                        padding: "2px",
                      }}
                    />
                  ) : null}
                </Stack>
              </Stack>
            </Stack>
            {/* <Divider sx={{ borderColor: "#FFFFFF19" }} /> */}
            <Stack
              direction="row"
              sx={{ display: "grid", gridTemplateColumns: "50% 50%" }}
            >
              <Stack direction="column" spacing={1}>
                <Typography className="fs-13 fade-text-60">
                  {t("nftDetail.detail.createdDate")}
                </Typography>
                <Typography className="fs-16 fw-b">
                  {formatedDate(playlistDetail["createdDate"])}
                </Typography>
              </Stack>
            </Stack>
            {/* <Stack spacing={1}>
              <Typography className="fs-13 fade-text-60">
                NFT Owned ({owners.length})
              </Typography>
              {owners &&
                owners.slice(0, 3).map((nft, index) => (
                  <Stack
                    key={index}
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Avatar
                      className="avatar"
                      src={nft["owner"]["profileImg"]["filePath"]}
                    />
                    <Stack direction="column">
                      <Typography className="fs-14">
                        {fullName(nft["owner"])}
                      </Typography>
                      <Typography className="fs-13 fade-text-60">
                        NFT’s owned: {nft["nftCount"]}
                      </Typography>
                    </Stack>
                  </Stack>
                ))}
              {owners.length > 0 ? (
                <Typography
                  className="fs-16 fade-text-60 underline _cp"
                  onClick={() => setViewMore(true)}
                >
                  View all
                </Typography>
              ) : null}
            </Stack> */}
            {/* <Divider sx={{ borderColor: "#FFFFFF19" }} /> */}
            {playlistDetail["releaseDate"] ? (
              <Stack spacing={0.5}>
                <Typography className="fs-13 fade-text">
                  {t("nftDetail.detail.releaseDate")}
                </Typography>
                <Typography className="fs-17">
                  {formatedDate(playlistDetail["releaseDate"])}
                </Typography>
              </Stack>
            ) : null}

            {playlistDetail["nftId"] ? (
              <Stack spacing={0.5}>
                <Typography className=" fs-13 fade-text">
                  {t("nftDetail.detail.nftId")}
                </Typography>
                <Typography className="fs-17">{owners?._id}</Typography>
              </Stack>
            ) : null}
            {!isOwnerId(owners["owner"]["_id"]) ? (
              <Box
                sx={{
                  height: "130px",
                  borderRadius: "15px",
                  border: "1px dashed #4D4D4D",
                  padding: "16px",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ height: "inherit" }}
                >
                  <Stack direction="column" sx={{ height: "inherit" }}>
                    <Typography className=" fs-20">
                      {t("tipContainer.header")}
                    </Typography>
                    <Typography className="fs-14">
                      {t("tipContainer.subHeader1")}
                    </Typography>
                    <Typography className="fs-14">
                      {t("tipContainer.subHeader2")}
                    </Typography>
                    <Button
                      onClick={() => setOpenTip(true)}
                      sx={{ height: "36px", marginTop: "auto" }}
                      variant="outlined"
                      color="default"
                    >
                      {t("tipContainer.button")}
                    </Button>
                  </Stack>
                  <img
                    style={{ width: "150px" }}
                    src={Images.tipOwner}
                    alt=""
                  />
                </Stack>
              </Box>
            ) : null}
          </Stack>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Stack
            sx={{
              // backgroundColor: "#262626",
              backgroundColor: "#171515",
              borderRadius: "16px",
              height: "41px",
              padding: "0 20px",
              display: "grid",
              gridTemplateColumns: "25% 25% 25% 25%",
              alignItems: "center",
            }}
          >
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th1")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th2")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th3")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.offers.th4")}
            </Typography>
          </Stack>
          {offers.length > 0 ? (
            offers.map((offer, index) => (
              <Stack
                key={index}
                sx={{
                  height: "41px",
                  padding: "5px 20px",
                  borderBottom: "1px solid #404040",
                  display: "grid",
                  gridTemplateColumns: "25% 25% 25% 25%",
                  alignItems: "center",
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={
                      offer["currency"] === "siki"
                        ? Images.siki_coin
                        : Images.hbar_1
                    }
                    alt=""
                  />
                  <Typography
                    className="white-secondary fs-14"
                    title={offer["amount"]}
                  >
                    {truncate(offer["amount"].toFixed(2), 5)}
                  </Typography>
                </Stack>
                <Typography className="white-secondary fs-14">
                  $ {truncate(offer["usdPrice"].toFixed(2), 5)}
                </Typography>
                <Typography className="white-secondary fs-14">
                  {offer["endDate"] ? getTimeDue(offer["endDate"]) : "-"}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar-sm"
                    src={
                      offer?.fromUser?.profileImg?.filePath ||
                      Images.default_user
                    }
                    alt="siki"
                  />
                  <Typography className="white-secondary fs-14">
                    {fullName(offer["fromUser"])}
                  </Typography>
                </Stack>
              </Stack>
            ))
          ) : (
            <Box sx={{ position: "relative", minHeight: "200px" }}>
              <NoData lable={t("noData.noData")} />
            </Box>
          )}
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Stack
            sx={{
              // backgroundColor: "#262626",
              backgroundColor: "#171515",
              borderRadius: "16px",
              height: "41px",
              padding: "0 20px",
              display: "grid",
              gridTemplateColumns: "11% 11% 11% 22% 22% 23%",
              alignItems: "center",
            }}
          >
            <Typography className="white-secondary fs-13">
              {t("nftDetail.activity.th1")}
            </Typography>
            <Typography className="white-secondary fs-13">
              {t("nftDetail.activity.th2")}
            </Typography>
            <Typography
              className="white-secondary fs-13 white-space-pre "
              title={t("nftDetail.activity.th3")}
            >
              {truncate(t("nftDetail.activity.th3"), 10)}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th4")}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th5")}
            </Typography>
            <Typography className="white-secondary fs-13 text-center">
              {t("nftDetail.activity.th6")}
            </Typography>
          </Stack>
          {activities.length > 0 ? (
            activities.map((activity, index) => (
              <Stack
                key={index}
                sx={{
                  height: "41px",
                  padding: "5px 20px",
                  borderBottom: "1px solid #404040",
                  display: "grid",
                  gridTemplateColumns: "10% 12% 12% 22% 22% 22%",
                  alignItems: "center",
                }}
              >
                <Typography className="white-secondary fs-14">
                  {activity["typeOfNft"]}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <img
                    style={{ width: "23px", height: "23px" }}
                    src={
                      activity["currency"] === "siki"
                        ? Images.siki_coin
                        : Images.hbar_1
                    }
                    alt=""
                  />
                  <Typography
                    className="white-secondary fs-14"
                    title={activity["amount"]}
                  >
                    {truncate(activity["amount"].toFixed(2), 5)}
                  </Typography>
                </Stack>
                <Typography
                  className="white-secondary fs-14"
                  title={activity["usdPrice"]}
                >
                  $ {truncate(activity["usdPrice"].toFixed(2), 5)}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar-sm"
                    src={
                      activity?.fromUser?.profileImg?.filePath ||
                      Images.default_user
                    }
                    alt="siki"
                  />
                  <Typography className="white-secondary fs-14">
                    {fullName(activity["fromUser"])}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img
                    className="avatar-sm"
                    src={
                      activity?.toUser?.profileImg?.filePath ||
                      Images.default_user
                    }
                    alt="siki"
                  />
                  <Typography className="white-secondary fs-14">
                    {fullName(activity["toUser"])}
                  </Typography>
                </Stack>
                <Typography className="white-secondary fs-14 text-center">
                  {formatedDate(activity["createdAt"], true, true, false, true)}
                </Typography>
              </Stack>
            ))
          ) : (
            <Box sx={{ position: "relative", minHeight: "200px" }}>
              <NoData lable={t("noData.noData")} />
            </Box>
          )}
        </TabPanel>
      </Box>
      {viewMore ? (
        <BuyNow
          view={true}
          owners={owners}
          open={viewMore}
          handleClose={() => setViewMore(false)}
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={
            owners["owner"]
              ? fullName(owners["owner"])
              : fullName(owners["uploader"])
          }
          id={
            owners["owner"] ? owners["owner"]["_id"] : owners["uploader"]["_id"]
          }
          open={openTip}
          isArtist={true}
          handleClose={handleClose}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={t("loader.message10")}
        />
      ) : null}
    </Box>
  );
}
